import React from "react";
import { PackageSection } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Link from "next/link";
import { renderRichText } from "@/lib/richText";

interface PackageSectionProps {
  blok?: PackageSection & SbBlokData;
}

const PackageSectionComponent: React.FC<PackageSectionProps> = ({ blok }) => {
  if (!blok) return null;

  const { title, subtitle, packages } = blok;
  // const isPPPackage = packages?.some(pkg => pkg.type?.endsWith('-pp'));

  return (
    <div className="bg-dark" id="packages">
      <section className="container py-4 py-md-5" {...storyblokEditable(blok)}>
        <h2 className="text-center text-white mb-3">{title}</h2>
        {subtitle && (
          <p className="lead text-center text-white mb-4 mb-xl-5">
            {subtitle}
          </p>
        )}

        <div className="row justify-content-center g-xl-4 pt-4">
          {packages?.map((pkg) => {
            const isPPType = pkg.type?.endsWith('-pp');

            return (
              <div key={pkg._uid} className="col-24 col-lg-16 col-xl-8 mb-5 mb-xl-0">
                <div className={`card card-lighter h-100 overflow-visible card-package ${pkg.type}`}>
                  <div className="card-header py-4 px-3 text-center">
                    {pkg.icon && <div dangerouslySetInnerHTML={{ __html: pkg.icon }} />}
                    <h3 className={isPPType ? "text-black" : ""}>
                      {pkg.title}
                    </h3>
                    {isPPType && pkg.duration && (
                      <h4 className="text-black">{pkg.duration}</h4>
                    )}
                    {isPPType && (
                      <div className="lh-1 text-center p-2">
                        <div className="h1 mb-0">
                          <span className="text-dark">{pkg.price || "POA"}</span>
                        </div>
                      </div>
                    )}
                    <p className="mb-0">{pkg.description}</p>
                  </div>
                  <div className="card-body p-4">
                    {pkg.body && (
                      <div dangerouslySetInnerHTML={{ __html: renderRichText(pkg.body) }} />
                    )}
                  </div>
                  <div className="card-cyber-essentials-footer">
                    {pkg.cta_button_link && (
                      <Link
                        href={pkg.cta_button_link.cached_url || "#getQuote"}
                        className="button button-large button-secondary d-block text-center"
                      >
                        {pkg.cta_button || "Get a fast quote"}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default PackageSectionComponent;